import React, { useMemo } from 'react';
import styles from './card.module.scss';
import { Program } from '../../../types';
import { Link } from 'react-router-dom';
import { getMediaAbsolutePath } from '../../../services/File';
import { useMediaQuery } from 'react-responsive';
import FlagAU from 'src/assets/icons/icon_au.svg?react';
import FlagCA from 'src/assets/icons/icon_ca.svg?react';
import FlagUS from 'src/assets/icons/icon_us.svg?react';
import { useHistory } from 'react-router-dom';

type Props = {
  program: Program;
  showEdit?: boolean;
  isParentApp?: boolean;
  handleDuplicateCourse?: (program: Program) => void
};

const getFlagIcon = (type: String) => {
  switch (type) {
    case "Australia": {
      return <FlagAU className={styles.flag}/>;
    }
    case "Canada": {
      return <FlagCA className={styles.flag}/>;
    }
    case "USA": {
      return <FlagUS className={styles.flag}/>;
    }
    case "Canada & USA": {
      return <><FlagCA className={styles.flag}/><FlagUS className={styles.flag}/></>;
    }
    default: {
      return null;
    }
  }
}

function Card(props: Props) {
  const {
    program,
    isParentApp,
    handleDuplicateCourse
  } = props;
  const isMobile = useMediaQuery({maxWidth: 480});
  const history = useHistory();
  const { name, image, description, country } = program;

  const descriptionClasses = useMemo(() => {
    const classes = [styles.description];
    if (isMobile) {
      classes.push(styles.hidden);
    }
    return classes.join(' ');
  }, [isMobile]);

  const handleViewUnits = (course: Program) => {
    history.push({ pathname: `/super/courses/units/${program.id}`, state: { program: course } })
  }

  const link = isParentApp ? `/parent/program/${program.id}` : `/program/${program.id}`;

  return (
    <article className={styles.card}>
      <Link to={link} className={styles.image}
            style={{ backgroundImage: `url(${image ? getMediaAbsolutePath(image) : ''})` }}/>
      <section className={styles.content}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>{name}</div>
          <div className={styles.favoriteWrapper}>
            <div>
              {getFlagIcon(`${country}`)}
            </div>
          </div>
        </div>
        <div className={descriptionClasses}>
          <div>{description}</div>
        </div>
        <div className={styles.actions}>
          <Link to={link} className={styles.startText}>View Course</Link>
          <Link to={`/super/courses/edit/${program.id}`} className={styles.startText}>Edit Course</Link>
          <div onClick={() => handleDuplicateCourse && handleDuplicateCourse(program)} className={styles.duplicateText}>Duplicate Course</div>
          <div onClick={() => handleViewUnits(program)} className={styles.duplicateText}>View Units</div>
        </div>
      </section>
    </article>
  );
}

export default Card;
